import { colors } from '@lmc/common/constants'
import { isNumber } from 'lodash'
import React, { type ReactElement } from 'react'
import LabelIcon from '../../LabelIcon'

export type ActualStockCellProps = {
  actualStock?: number | string
  deleted?: boolean
  expectedStock?: number | string
  onSelect?: () => void
  showExpectedStock?: boolean
}

export default function ActualStockCell({
  actualStock,
  deleted,
  expectedStock,
  onSelect,
  showExpectedStock
}: ActualStockCellProps): ReactElement {
  // @ts-ignore
  if (deleted) return null

  const alert = expectedStock !== actualStock
  const iconName =
    isNumber(expectedStock) && isNumber(actualStock) && showExpectedStock
      ? alert
        ? 'overdue'
        : 'tick-in-circle'
      : null

  const cellStyle = {
    ...styles.cell,
    ...(!!onSelect && { cursor: 'pointer' })
  }

  // @ts-ignore
  return actualStock === undefined ? null : (
    <div
      onClick={onSelect}
      onKeyPress={onSelect}
      role="link"
      style={cellStyle}
      tabIndex={0}
    >
      <LabelIcon
        iconColor={alert ? colors.orange : colors.successgreen}
        // @ts-ignore
        iconName={iconName}
        iconPosition="right"
        iconSize={24}
        text={actualStock?.toString()}
      />
    </div>
  )
}

const styles = {
  cell: {
    display: 'flex',
    justifyContent: 'center'
  }
}
